import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type DuplicateSurveyMutationVariables = Types.Exact<{
  input: Types.DuplicateSurveyInput;
}>;


export type DuplicateSurveyMutation = { duplicateSurvey: { survey?: { id: string } | null } };


export const DuplicateSurveyDocument = /*#__PURE__*/ gql`
    mutation duplicateSurvey($input: DuplicateSurveyInput!) {
  duplicateSurvey(data: $input) {
    survey {
      id
    }
  }
}
    `;

export function useDuplicateSurveyMutation() {
  return Urql.useMutation<DuplicateSurveyMutation, DuplicateSurveyMutationVariables>(DuplicateSurveyDocument);
};